import { render, staticRenderFns } from "./CommunitySettingsGeneral.vue?vue&type=template&id=42a08547&scoped=true&"
import script from "./CommunitySettingsGeneral.vue?vue&type=script&lang=js&"
export * from "./CommunitySettingsGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a08547",
  null
  
)

export default component.exports